import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { AppContext } from "../../App";
import functions from "../../functions/functions";
import VariantsPopUp from "../VariantsPopUp";
import PlusIcon from "../../icons/PlusIcon";
import SearchIcon from "../../icons/SearchIcon";
import { useAppStore } from "../../store/useAppStore";
import { loadFavoriteProductIds, saveFavoriteProductIds } from "../../utils/productFavorites";
import AllergenFilterPopup from "../AllergenFilterPopup";
import {
	ALLERGEN_PRINT_NAMES,
	DIETS,
	emptyFilter,
	filterKey,
	isFilterActive,
	productStatus,
	reasonsLabel,
} from "../../utils/allergenFilter";

function Products() {
	const {
		category,
		add_product,
		setPopup,
		mode,
		categoryPos,
		filteredCategories,
		setConfirm,
		setOverlay,
		init_cart,
		cart,
		apiSettings,
		user,
		allergenFilter,
		setAllergenFilter,
		allergenFilterEnabled,
	} = useContext(AppContext);
	const allergenFilterOn = allergenFilterEnabled && isFilterActive(allergenFilter);
	const { setSplittedOrders, setSplittedOrdersCount } = useAppStore();
	const [filteredProducts, setfilteredProducts] = useState([]);
	const [src, setSrc] = useState("");
	const [srcProducts, setSrcProducts] = useState([]);
	const [favoriteProductIds, setFavoriteProductIds] = useState([]);

	useEffect(() => {
		if (filteredCategories && categoryPos) assignProductsToPosCategories();
	}, [filteredCategories, categoryPos]);

	useEffect(() => {
		filter();
	}, [src]);

	useEffect(() => {
		setFavoriteProductIds(loadFavoriteProductIds(user?.id));
	}, [user?.id]);

	function handleClick(product) {
		console.log("handleClick", product.stock);
		if (allergenFilterOn) {
			const st = productStatus(product, allergenFilter);
			if (st.status === "locked") {
				setConfirm({
					title: "Filtro allergie",
					message: product.name + " contiene: " + reasonsLabel(st.reasons) + ". Spegni il filtro per aggiungerlo.",
				});
				return;
			}
		}
		const disableStockCheckPos = apiSettings?.menu_api?.disable_stock_check_operators == 1;
		if (
			!disableStockCheckPos &&
			(checkProductsStock(product) ||
				checkIngredientsStock(product.stock ? product.stock.ingredients : []))
		) {
			setConfirm({
				title: "Prodotto esaurito",
			});
		} else if (product.variants_categories.length === 0 && !hasRemovbleIngredients(product))
			add_product(product);
		else
			setPopup({
				title: <VariantsPopupTitle product={product} />,
				customClass: "variants-product-popup",
				fullContent: <VariantsPopUp product={product} />,
			});
	}

	function checkProductsStock(product) {
		console.log("checkProductsStock");
		if (product.stock && product.stock.product !== false) {
			let stock = product.stock.product;
			for (const element of cart.products) {
				if (element.id == product.id) stock -= element.qty;
			}
			if (stock == 0) return true;
		}
		return false;
	}

	function checkIngredientsStock(ingredients) {
		for (const i of ingredients) {
			let sum = i.qty;
			for (const product of cart.products) {
				for (const ingredient of product.ingredients) {
					if (ingredient.id == i.ingredient_id) sum -= product.qty;
				}
			}
			if (sum == 0) return true;
		}
		return false;
	}

	function hasRemovbleIngredients(product) {
		for (const ingredient of product.ingredients) {
			if (ingredient.removable == 1) return true;
		}
		return false;
	}

	function assignProductsToPosCategories() {
		console.log("assignProductsToPosCategories");
		let arr = [];
		for (const p of categoryPos.products) {
			filteredCategories.map((course) =>
				course.categories.map((category) =>
					category.products.map((product) => {
						if (product.id == p.id) arr.push(product);
					})
				)
			);
		}
		arr.sort(function (a, b) {
			return a["name"] > b["name"] ? 1 : -1;
		});
		setfilteredProducts(arr);
	}

	function filter() {
		console.log("filter");
		let arr = [];
		if (src) {
			filteredCategories.map((course) =>
				course.categories.map((category) =>
					category.products.map((product) => {
						console.log(product.name, src, product.name.includes(src));
						if (product.name.toLowerCase().includes(src.toLowerCase()))
							arr.push(product);
					})
				)
			);
		}
		arr.sort(function (a, b) {
			return a["name"] > b["name"] ? 1 : -1;
		});
		setSrcProducts(arr);
	}
	function getTitle() {
		if (src) return "Risultati della ricerca";
		if (!src && mode == 1) return category.name;
		if (!src && mode == 2) return categoryPos.name;
	}

	function toggleFavorite(productId) {
		if (!user?.id) return;
		const nextFavorites = favoriteProductIds.includes(productId)
			? favoriteProductIds.filter((id) => id !== productId)
			: [...favoriteProductIds, productId];
		setFavoriteProductIds(nextFavorites);
		saveFavoriteProductIds(user.id, nextFavorites);
	}

	function handleFavoriteClick(product) {
		const isFavorite = favoriteProductIds.includes(product.id);
		setConfirm({
			title: "Aggiungere/rimuovere dai preferiti?",
			message: isFavorite
				? "Il prodotto verra rimosso dai preferiti."
				: "Il prodotto verra aggiunto ai preferiti.",
			onConfirm: () => toggleFavorite(product.id),
		});
	}

	return (
		<div className="products">
			<SearchHeader
				title={getTitle()}
				src={src}
				setSrc={setSrc}
				allergenButton={
					allergenFilterEnabled && (
						<button
							type="button"
							className={"allergen-filter-button" + (allergenFilterOn ? " active" : "")}
							onClick={() =>
								setPopup({
									title: "Filtro allergie",
									customClass: "allergen-filter-product-popup",
									fullContent: <AllergenFilterPopup />,
								})
							}
						>
							{"⚠ Allergie" +
								(allergenFilterOn
									? " (" + (allergenFilter.allergens.length + allergenFilter.diets.length) + ")"
									: "")}
						</button>
					)
				}
			/>
			{allergenFilterOn && (
				<div className="allergen-filter-band">
					<div className="allergen-filter-band-text">
						<b>{"Filtro allergie: " + allergenFilterLabel(allergenFilter)}</b>
						<span>
							I prodotti che aggiungi ora porteranno l'allergia in comanda. Si spegne con Invia o Nuovo
							ordine.
						</span>
					</div>
					<button
						type="button"
						onClick={() =>
							setPopup({
								title: "Filtro allergie",
								customClass: "allergen-filter-product-popup",
								fullContent: <AllergenFilterPopup />,
							})
						}
					>
						Modifica
					</button>
					<button type="button" onClick={() => setAllergenFilter(emptyFilter())}>
						Spegni
					</button>
				</div>
			)}
			{src && (
				<>
					<div className="scroll">
						<ProductGrid
							products={srcProducts}
							favoriteProductIds={favoriteProductIds}
							onProductClick={handleClick}
							onFavoriteClick={handleFavoriteClick}
						/>
					</div>
				</>
			)}
			{!src && mode == 1 && (
				<>
					<div className="scroll">
						<ProductGrid
							products={category.products || []}
							favoriteProductIds={favoriteProductIds}
							onProductClick={handleClick}
							onFavoriteClick={handleFavoriteClick}
						/>
					</div>
				</>
			)}
			{!src && mode == 2 && (
				<>
					<div className="scroll">
						<ProductGrid
							products={filteredProducts}
							favoriteProductIds={favoriteProductIds}
							onProductClick={handleClick}
							onFavoriteClick={handleFavoriteClick}
						/>
					</div>
				</>
			)}

			<div className="new-order">
				<button
					onClick={() =>
						setConfirm({
							title: "Sei sicuro?",
							message: "",
							onConfirm: () => {
								setOverlay(false);
								setSplittedOrders([]);
								setSplittedOrdersCount(0);
								init_cart();
							},
						})
					}
				>
					<PlusIcon />
				</button>
			</div>
		</div>

	);
}

function VariantsPopupTitle({ product }) {
	const [previewOpen, setPreviewOpen] = useState(false);
	const productImage = getProductImage(product);

	return (
		<>
			<div className="variants-popup-title">
				{productImage ? (
					<button
						type="button"
						className="variants-popup-image-button"
						onClick={(e) => {
							e.stopPropagation();
							setPreviewOpen(true);
						}}
						aria-label="Apri immagine prodotto"
					>
						<img src={productImage} alt={product?.name || "Prodotto"} />
					</button>
				) : (
					<div className="variants-popup-icon" aria-hidden="true">
						{String(product?.name || "P")
							.trim()
							.charAt(0)
							.toUpperCase()}
					</div>
				)}
				<div>{product?.name}</div>
			</div>
			{previewOpen && productImage && (
				<div
					className="variants-image-lightbox"
					onClick={() => setPreviewOpen(false)}
					role="button"
					tabIndex={0}
					aria-label="Chiudi anteprima immagine"
					onKeyDown={(e) => {
						if (e.key === "Escape" || e.key === "Enter" || e.key === " ")
							setPreviewOpen(false);
					}}
				>
					<img src={productImage} alt={product?.name || "Prodotto"} />
				</div>
			)}
		</>
	);
}

function getProductImage(product) {
	const image = product?.img || product?.image || product?.thumbnail || product?.thumb || "";
	const normalized = String(image || "").trim();
	return normalized.length > 0 ? normalized : null;
}

function hexToRgba(hex, alpha) {
	const normalized = String(hex || "")
		.trim()
		.replace("#", "");
	if (![3, 6].includes(normalized.length)) return `rgba(36, 64, 75, ${alpha})`;

	const value =
		normalized.length === 3
			? normalized
					.split("")
					.map((char) => char + char)
					.join("")
			: normalized;

	const int = Number.parseInt(value, 16);
	const r = (int >> 16) & 255;
	const g = (int >> 8) & 255;
	const b = int & 255;

	return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

function getProductCardOpacityByColumns(index, columnsCount) {
	const safeColumnsCount = Math.max(1, Number(columnsCount) || 1);
	const row = Math.floor((Number(index) || 0) / safeColumnsCount);
	if (row <= 0) return 1;
	if (row === 1) return 0.95;
	if (row === 2) return 0.9;
	if (row === 3) return 0.85;
	return 0.8;
}

function allergenFilterLabel(filter) {
	const names = filter.allergens.map((id) => ALLERGEN_PRINT_NAMES[id] || id);
	const diets = DIETS.filter((d) => filter.diets.includes(d.id)).map((d) => d.label);
	return [...names, ...diets].join(", ");
}

function SearchHeader({ title, src, setSrc, allergenButton }) {
	return (
		<div className={"src-grid" + (allergenButton ? " with-allergen" : "")}>
			<h3>{title}</h3>
			{allergenButton}
			<div className="src">
				<input
					type="text"
					placeholder="Cerca prodotto"
					value={src}
					onChange={(e) => setSrc(e.target.value)}
				/>
				<div className="src-actions">
					{src && (
						<button
							type="button"
							className="src-clear"
							onClick={() => setSrc("")}
							aria-label="Pulisci ricerca"
						>
							×
						</button>
					)}
					<span className="src-icon" aria-hidden="true">
						<SearchIcon />
					</span>
				</div>
			</div>
		</div>
	);
}

function ProductGrid({ products, favoriteProductIds, onProductClick, onFavoriteClick }) {
	const gridRef = useRef(null);
	const [columnsCount, setColumnsCount] = useState(1);

	useEffect(() => {
		const updateColumnsCount = () => {
			if (!gridRef.current) return;
			const computedStyle = window.getComputedStyle(gridRef.current);
			const templateColumns = computedStyle.getPropertyValue("grid-template-columns");
			const columns = templateColumns
				.split(" ")
				.map((value) => value.trim())
				.filter(Boolean).length;

			setColumnsCount(columns || 1);
		};

		updateColumnsCount();

		const observer = new ResizeObserver(() => updateColumnsCount());
		if (gridRef.current) observer.observe(gridRef.current);
		window.addEventListener("resize", updateColumnsCount);

		return () => {
			observer.disconnect();
			window.removeEventListener("resize", updateColumnsCount);
		};
	}, []);

	return (
		<div className="grid" ref={gridRef}>
			{products.map((prod, n) => (
				<Product
					key={n}
					prod={prod}
					index={n}
					columnsCount={columnsCount}
					onClick={() => onProductClick(prod)}
					isFavorite={favoriteProductIds.includes(prod.id)}
					onFavoriteClick={() => onFavoriteClick(prod)}
				/>
			))}
		</div>
	);
}

function Product({ prod, index, columnsCount, onClick, isFavorite, onFavoriteClick }) {
	const { config, cart, allergenFilter, allergenFilterEnabled } = useContext(AppContext);
	const productImage = getProductImage(prod);
	const allergenFilterOn = allergenFilterEnabled && isFilterActive(allergenFilter);
	const allergenKey = allergenFilterOn ? filterKey(allergenFilter) : "";
	const allergen = useMemo(
		() => (allergenFilterOn ? productStatus(prod, allergenFilter) : null),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[prod, allergenKey]
	);
	const showProductImage =
		config?.show_product_image === undefined ||
		config?.show_product_image === 1 ||
		config?.show_product_image === "1" ||
		config?.show_product_image === true;
	const productAccentColor = prod?.color || "transparent";
	const canShowImage = showProductImage && Boolean(productImage);
	const backgroundOpacity = getProductCardOpacityByColumns(index, columnsCount);
	const productBackgroundStyle = {
		background: `linear-gradient(180deg, ${hexToRgba("#24404b", backgroundOpacity)} 0%, ${hexToRgba(
			"#1d333d",
			backgroundOpacity,
		)} 100%)`,
	};

	function getProductsStock(product) {
		console.log("getProductsStock");
		if (product.stock && product.stock.product !== false) {
			let stock = product.stock.product;
			for (const element of cart.products) {
				if (element.id == product.id) stock -= element.qty;
			}
			return stock;
		}
		return false;
	}

	return (
		<div
			className={
				"product-card " +
				config.product_button_height +
				(allergen ? " allergen-" + allergen.status : "")
			}
			onClick={onClick}
			onKeyDown={(e) => {
				if (e.key === "Enter" || e.key === " ") {
					e.preventDefault();
					onClick();
				}
			}}
			role="button"
			tabIndex={0}
		>
			<button
				type="button"
				className={"product-favorite-button" + (isFavorite ? " active" : "")}
				onClick={(e) => {
					e.stopPropagation();
					onFavoriteClick();
				}}
				aria-label={isFavorite ? "Rimuovi dai preferiti" : "Aggiungi ai preferiti"}
			>
				&#9733;
			</button>
			{allergen && (
				<div className={"allergen-badge " + allergen.status}>
					{allergen.status === "locked"
						? "🔒 " + reasonsLabel(allergen.reasons).toUpperCase()
						: allergen.status === "adaptable"
							? "SOSTITUIBILE"
							: "OK"}
				</div>
			)}
			<div className="product-info" style={productBackgroundStyle}>
				{prod.category_name && (
					<div className="product-category-name">{prod.category_name}</div>
				)}
				<div className="product-name">{prod.name && prod.name.replaceAll("_", " ")}</div>
				<div className="stock">
					{prod.stock && prod.stock.product !== false && (
						<div>Restanti: {getProductsStock(prod)}</div>
					)}
					{prod.discounted && prod.discount_remaining != null && (
						<div>Sconto: {prod.discount_remaining} rimasti</div>
					)}
				</div>
				<div className="product-footer">
					{canShowImage ? (
						<div
							className="product-thumb"
							style={{ borderColor: productAccentColor }}
						>
							<img src={productImage} alt={prod.name || "Prodotto"} />
						</div>
					) : (
						<div
							className="product-thumb product-thumb-swatch"
							style={{
								borderColor: productAccentColor,
								backgroundColor: productAccentColor,
							}}
							aria-hidden="true"
						></div>
					)}
					<div className="product-price">
						{prod.discounted && prod.original_price != null && (
							<span
								className="product-price-original"
								style={{ textDecoration: "line-through", opacity: 0.6, marginRight: 6, fontSize: "0.85em" }}
							>
								{functions.formatter.format(prod.original_price)}
							</span>
						)}
						{functions.formatter.format(prod.price)}
					</div>
				</div>
			</div>
			<div className="product-color" style={{ backgroundColor: productAccentColor }}></div>
		</div>
	);
}

export default Products;
